// Mirrors zeos-api Services/Territory/V2/Contracts/UtilityIntelligenceProfile.cs.
export enum UtilityResolutionStatus {
  Unresolved = "UNRESOLVED",
  Resolved = "RESOLVED",
  Ambiguous = "AMBIGUOUS",
  OutOfCoverage = "OUT_OF_COVERAGE",
  NoTerritoryModel = "NO_TERRITORY_MODEL",
}

/** Common__UtilityAssignment.AssignmentSource. */
export enum UtilityAssignmentSource {
  System = "system",
  UserSelected = "user_selected",
  AdminOverride = "admin_override",
}

export interface IConnectorSupportContract {
  connectorName: string;
  /** api | green_button | manual */
  connectionType: string;
  /** active | beta | none */
  coverageState: string;
}

/** UTL P06. Present only when the service is RESOLVED. */
export interface IConnectorSelection {
  /** auto | choose | manual */
  mode: "auto" | "choose" | "manual";
  /** Set only when mode is auto. */
  connectorName?: string | null;
  options?: IConnectorSupportContract[];
}

export interface IUtilityCandidate {
  utilityId: number;
  utilityName: string;
}

export interface IServiceResolutionResult {
  /** electric | natural_gas | district_steam ... */
  serviceCode: string;
  status: UtilityResolutionStatus;
  utilityId?: number | null;
  utilityName?: string | null;
  candidates: IUtilityCandidate[];
  connectors: IConnectorSupportContract[];
  /** Null unless this service is RESOLVED. */
  connectorSelection?: IConnectorSelection | null;
  programAdministrators: string[];
  territoryKey?: string | null;
  sourceDataset?: string | null;
  /** Cascade tier that matched (boundary | zip_county | zip | municipality_state); null when unmatched. */
  matchTier?: string | null;
  /** Stored profile only (GET): system | user_selected | admin_override. Null on a fresh lookup. */
  assignmentSource?: UtilityAssignmentSource | string | null;
}

export interface IUtilityIntelligenceProfile {
  propertyId: number;
  datasetVersion: string;
  /** ISO timestamp of the lookup (fresh) or of the latest stored assignment (GET). */
  resolutionTimestamp?: string;
  services: IServiceResolutionResult[];
  /** Story 3949: from the geocode alone, present even when every service is unresolved. */
  jurisdiction?: IJurisdiction | null;
}

export interface IJurisdiction {
  status: string;
  state?: string | null;
  county?: string | null;
  municipality?: string | null;
  zip?: string | null;
  /** Same rule as compliance: NYC city name or a ZIP in the NYC ZIP table. */
  isNyc: boolean;
}
